import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { useHydrating } from "eddev/routing"
import Marquee from "react-fast-marquee"

export const meta: BlockMeta = {
  title: "Text Marquee",
  tags: ["#page"],
}

export default defineBlock("content/text-marquee", (props) => {
  const isHydrating = useHydrating()

  return (
    <div className="w-[100vw] overflow-hidden my-blockSpace flex flex-col items-center justify-between gap-4">
      {env.admin || isHydrating ? (
        <MarqueeText />
      ) : (
        <>
          <Marquee>
            <MarqueeText />
          </Marquee>
          <div className="md:hidden">
            <Marquee direction="right">
              <MarqueeText />
            </Marquee>
          </div>
        </>
      )}
    </div>
  )
})

const MarqueeText = () => {
  return (
    <>
      <EditableText
        store="marqueeText"
        as="span"
        className="inline-block type-sans-2-xl-regular md:type-sans-5-xl-regular leading-relaxed py-[0.25em]"
        defaultValue="Regulated infrastructure solutions — Institutional expertise — Regulated infrastructure solutions"
        placeholder="Marquee Text"
      />
      <span className="inline-block" dangerouslySetInnerHTML={{ __html: "&nbsp;&nbsp;&nbsp;" }} />
    </>
  )
}
